<template>
  <div class="signup">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-md-6 bordered">
          <div class="box">
            <div
              class="singup-page-content"
              v-html="content"
            />
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="signup-header">
            <h2>Create an Account</h2>
          </div>
          <template v-if="userLoggedIn">
            <FormResult
              message-type="none"
              :reset-button="false"
              message-h1="Oops!"
              message-p="You are already logged in. If you want to sign up another account please log out first."
            />
          </template>
          <template v-else>
            <!-- Start Form -->
            <template v-if="!signed">
              <signup-form :links="links" />
            </template>
            <!-- / End Form -->

            <!-- Present Form Success/Error Message -->
            <template v-else-if="signed === 'success'">
              <FormResult
                :message-type="signed"
                :reset-button="false"
                message-h1="Great!"
                message-p="Thank you. We have sent you an email with a link to activate your new account."
              />
            </template>
            <template v-else-if="signed === 'error'">
              <FormResult
                :message-type="signed"
                :reset-button="true"
                message-h1="Oops!"
                message-p="Sorry, we could not create your account."
              />
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormResult from "../components/FormResult";
import SignupForm from "./SignupForm.vue"
import { pageMixin } from "../mixins/signup";

let defaultContent = `<div class='wrapper'>
  Create an account today and gain instant access to exclusive benefits including:

  <div class='membership-options'>
    Special offers:
    <ul>
      <li>Ability to save addresses, access invoices and update your details</li>
      <li>Stay up to date with the latest news, events and premium wine releases</li>
    </ul>
  </div>
</div>`;

export default {
  name: "signup",
  asyncData({ store, route }) {
    return store.getters["getGraphQLClient"]()
      .query({
        query:
          'query { content: variable(name: "vincreative_signup_page_content") }'
      })
      .then(resp => {
        if (resp.data.content.vincreative_signup_page_content) {
          defaultContent = resp.data.content.vincreative_signup_page_content;
        }
      });
  },
  mixins: [pageMixin],
  components: {
    FormResult,
    SignupForm
  },
  props: {
    illustration: {
      type: String,
      default: require("../assets/signup_illustration.svg")
    },
    links: {
      type: Object,
      default: () => ({
        terms: "/terms-and-conditions",
        privacy: "/privacy-policy"
      })
    }
  },
  data() {
    return {
      showVerification: false,
      content: defaultContent
    };
  },
  computed: {
    userLoggedIn() {
      return (this.$store.getters["user/userid"] && !this.$store.state.progressLoaderState) || false;
    }
  },
  methods: {
    resetForm() {
      this.signed = null;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@scss/custom.scss";

.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .flex {
    flex: 1;
    padding: 1em;

    &.bordered {
      border-left: 1px solid;
      border-color: var(--main-border-color);
    }
  }
}

.comms-preferences-container {
  margin: 1rem 0em;
  padding: 0;
}

.signup {
  .signup-button {
    padding: 1em 1em;
    width: 100%;
    margin: 1em 0;
  }
  .signup-header {
    margin-bottom: 1em;
  }

  .bg-light {
    height: 100vh;
  }
  .signup {
    padding: 6em 0em;
  }

  .form-check {
    padding: 0;

    &.disabled {
      cursor: not-allowed;
      label {
        opacity: 0.5;
        @include transition(opacity 0.3s);
      }
    }
  }
}
.singup-page-content {
 ::v-deep .image-container {
    margin-bottom: 1rem;
  }
}
</style>
